export const USAGE_DECISION_YES = "yes";
export const USAGE_DECISION_NO = "no";

export const isSettableUsageStatus = (status) => {
    return status === USAGE_DECISION_YES || status === USAGE_DECISION_NO;
};

/**
 * The API sets this. Do not infer it from adoption type.
 *
 * @param {{ requires_user_confirmation?: boolean }} measure
 * @returns {boolean}
 */
export const measureRequiresUserConfirmation = (measure) => {
    return measure?.requires_user_confirmation === true;
};
